import type { ContestCreateResponse } from "@betterpool/api-types/contests-service";

import { reportEvent } from "~/domains/analytics";

import type { FormValues } from "../common/types/FormValues";
import type { FormattedErrors } from "../common/context/utils/formatZodErrors";
import type { TouchedValues } from "../common/context/ContestManageContext";
import getFlattenValuesForEventReports from "../common/utils/getFlattenValuesForEventReports";

export function reportCreateContestStart() {
  reportEvent('Commissioner > Create Contest - Start');
}

export function reportCreateContestAbandon({
  values,
  errors,
  touched,
}: {
  values: FormValues;
  errors: FormattedErrors;
  touched: TouchedValues;
}) {
  reportEvent('Commissioner > Create Contest - Abandon', {
    values: getFlattenValuesForEventReports(values ?? {}),
    errors: errors ? getFlattenValuesForEventReports(errors) : {},
    touched: touched ? getFlattenValuesForEventReports(touched) : {},
  });
}

export function reportCreateContestSuccess(data: ContestCreateResponse) {
  reportEvent('Commissioner > Create Contest', {
    contest_name: data.contestName,
    contest_id: data.id,
    contest_template: data.contestTemplateId,
    contest_tags: data.tags,
    entry_fee: data.entryCost / 100,
    is_private: data.unlisted,
    payout_type: data.payoutType,
    max_entries: data.maxEntries,
    max_entries_per_user: data.maxEntriesPerUser,
    tags: data.tags.map((tag) => tag.name),
    contest_type: data.contestType,
    contest_league: data.leagueAlias,
  });
}

export function reportCreateContestError(message: string) {
  reportEvent('Commissioner > Create Contest - Error', {
    reason: message,
  });
}

export function reportCreateContestNextSectionClick({
  sectionKey,
  values,
}: {
  sectionKey: string;
  values: FormValues;
}) {
  reportEvent('Commissioner > Create Contest - Next Section Click', {
    sectionKey,
    values: getFlattenValuesForEventReports(values ?? {}),
  });
}
